var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "default-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-table" },
          [
            _c("b-table", {
              staticClass: "list-table",
              attrs: {
                responsive: "",
                fields: _vm.fields,
                items: _vm.claims,
                "show-empty": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                        You have no claims\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(data) {
                    return [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              href: _vm.$laravelRoute(
                                "claims.show",
                                data.item.id
                              )
                            }
                          },
                          [_vm._v("View")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              href: _vm.$laravelRoute(
                                "claims.edit",
                                data.item.id
                              )
                            }
                          },
                          [_vm._v("Edit")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: { href: "#!" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteClaim(data.item)
                              }
                            }
                          },
                          [_vm._v("Delete")]
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "cell(user)",
                  fn: function(data) {
                    return [
                      data.item && data.item.user
                        ? [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.item.user.name) +
                                "\n                        "
                            )
                          ]
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(vehicle)",
                  fn: function(data) {
                    return [
                      data.item.vehicle
                        ? _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.item.vehicle.make) +
                                " " +
                                _vm._s(data.item.vehicle.model) +
                                ", " +
                                _vm._s(data.item.vehicle.year) +
                                "\n                        "
                            )
                          ])
                        : _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.item.make) +
                                " " +
                                _vm._s(data.item.model) +
                                ", " +
                                _vm._s(data.item.chassis) +
                                "\n                        "
                            )
                          ])
                    ]
                  }
                },
                {
                  key: "cell(status)",
                  fn: function(data) {
                    return [
                      data.item.status == 1
                        ? _c("div", [
                            _c("span", { staticClass: "badge badge-warning" }, [
                              _vm._v("Pending")
                            ])
                          ])
                        : data.item.status == 2
                        ? _c("div", [
                            _c("span", { staticClass: "badge badge-primary" }, [
                              _vm._v("In Process")
                            ])
                          ])
                        : data.item.status == 3
                        ? _c("div", [
                            _c("span", { staticClass: "badge badge-success" }, [
                              _vm._v("Processed")
                            ])
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-table" },
          [
            _vm.total > 0
              ? _c("b-pagination", {
                  attrs: { "total-rows": _vm.total, "per-page": _vm.per_page },
                  model: {
                    value: _vm.current_page,
                    callback: function($$v) {
                      _vm.current_page = $$v
                    },
                    expression: "current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-result-top" }, [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "left" }, [
          _c("h2", [
            _vm._v(
              "\n                            Claims\n                        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                href: "/files/SBL_Claims_Policy_October_2022.pdf",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n                            View Claims policy\n                        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c("small", { staticClass: "ml-auto" }, [
          _vm._v("If you'd like to make a claim, please go to "),
          _c("a", { attrs: { href: "/my-garage" } }, [_vm._v("My Garage")]),
          _vm._v(" and select the relevant vehicle.")
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a864ffb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a864ffb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2a864ffb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/List.vue
// module chunks = 0